export { StoreTextSpot as default } from './StoreTextSpot';
